module.exports = __webpack_public_path__ + "media/private_home/BROWSE_PRODUCTS-bbb3bd8f.jpg";